<template>
  <div class="maincontent__container" v-if="current === 3">
    <button class="maincontent__logo" @click="toggleCompanyInfo(0)">
      <img class="logo" src="../assets/Logo_SVO.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">SVO Bewind</span>
        <span class="maincontent__address">Vlissingen</span>
        <a class="maincontent__address" href="tel:06-395 31 443">
          tel: 06-395 31 443
        </a>
        <a class="maincontent__address" href="https://svobewind.nl/">
          Naar de website
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(1)">
      <img class="logo" src="../assets/bewindenmeer.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">Bewind en meer</span>
        <span class="maincontent__address">Kamperland</span>
        <a class="maincontent__address" href="tel:0113-406094">
          tel: 0113-406094
        </a>
        <a class="maincontent__address" href="http://www.bewindenmeer.nl/">
          Naar de website
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(2)">
      <img class="logo" src="../assets/bosse.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">Van den Bosse</span>
        <span class="maincontent__address">Vlissingen</span>
        <a class="maincontent__address" href="tel: 0850190141">
          tel: 085-0190141
        </a>
        <a
          class="maincontent__address"
          href="https://vandenbossebewindvoeringen.nl/"
        >
          Naar de website
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(3)">
      <img class="logo" src="../assets/schelde_bewind.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">Schelde bewindv.</span>
        <span class="maincontent__address">Terneuzen</span>
        <a class="maincontent__address" href="tel:0115-696185">
          tel: 115-696185
        </a>
        <a class="maincontent__address" href="http://www.budget-support.nl/">
          Naar de website
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(4)">
      <img class="logo" src="../assets/julsing.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">Julsing</span>
        <span class="maincontent__address">Middelburg</span>
        <a class="maincontent__address" href="tel:0629040174">
          tel: 06-290 40 174
        </a>
        <a
          class="maincontent__address"
          href="https://www.julsingfinancieelsupport.nl/"
        >
          Naar de website
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(5)">
      <img class="logo" src="../assets/bbz.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">BBZ</span>
        <span class="maincontent__address">Terneuzen</span>
        <a class="maincontent__address" href="tel:0115-552019">
          tel: 0115-552019
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(6)">
      <img class="logo" src="../assets/obliv.png" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">Obliv</span>
        <span class="maincontent__address">Middelburg</span>
        <a class="maincontent__address" href="tel:0642287200">
          tel: 06-422 87 200
        </a>
        <a class="maincontent__address" href="https://www.obliv.nl/">
          Naar de website
        </a>
      </address>
    </button>
    <button class="maincontent__logo" @click="toggleCompanyInfo(7)">
      <img class="logo" src="../assets/logo_credit.jpg" />
      <address class="maincontent__company-info">
        <button class="maincontent__btn--close">
          <div class="icon--close">&#215;</div>
        </button>
        <span class="maincontent__address">Credit</span>
        <span class="maincontent__address">Terneuzen</span>
        <a class="maincontent__address" href="tel:0115-750597">
          tel: 0115-750597
        </a>
        <a
          class="maincontent__address"
          href="https://www.creditinkomensbeheerenbewindvoering.nl/"
        >
          Naar de website
        </a>
      </address>
    </button>
  </div>
</template>

<script>
export default {
  name: "Content",
  props: {
    current: Number
  },
  data() {
    return {};
  },
  methods: {
    toggleCompanyInfo(logoId) {
      let companies = document.getElementsByClassName(
        "maincontent__company-info"
      );
      if (
        companies[logoId].style.visibility == "hidden" ||
        companies[logoId].style.visibility == ""
      ) {
        companies[logoId].style.visibility = "visible";
        companies[logoId].style.opacity = "1";
      } else {
        companies[logoId].style.visibility = "hidden";
        companies[logoId].style.opacity = "0";
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/style.scss";

.maincontent__container {
  max-width: 20rem;
  margin: 2rem auto 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  @media only screen and (min-width: 768px) {
    max-width: 40rem;
    margin: 3rem auto 0;
  }
}

.maincontent__logo {
  height: 5.5rem;
  width: 8rem;
  margin-bottom: 1rem;
  padding: 0;
  position: relative;
  border: 2px $secondaryColor solid;
  border-radius: 10px;

  &:focus {
    outline: none;
  }

  img {
    width: 5rem;

    @media only screen and (min-width: 768px) {
      width: 6.5rem;
    }
  }

  @media only screen and (min-width: 768px) {
    height: 7rem;
    width: 11rem;
  }
}

.maincontent__more {
  font-size: 2rem;
}

.maincontent__company-info {
  visibility: hidden;
  width: 100%;
  height: 100%;
  padding: 0.5rem;
  position: absolute;
  top: 0;
  opacity: 0;
  border-radius: 6px;
  background-color: $secondaryColor;
  box-sizing: border-box;
  transition: opacity 0.2s ease;
}

.maincontent__btn--close {
  height: 45px;
  width: 45px;
  position: absolute;
  right: -35px;
  top: -35px;
  font-size: 2rem;
  font-weight: 500;

  .icon--close {
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1rem;
    color: $themeColor;
    border: 2px solid $themeColor;
    border-radius: 50%;
  }
}

a.maincontent__address {
  transition: color 0.3s ease;

  &:hover {
    color: $themeColor;
  }
}

.maincontent__address {
  display: block;
  font-size: 0.75rem;
  font-weight: 400;
  font-style: normal;
  color: white;
  text-align: left;
  text-decoration: none;

  &:last-child {
    margin-top: 0.5rem;
  }

  @media only screen and (min-width: 768px) {
    font-size: 1rem;
  }
}
</style>
